// extracted by mini-css-extract-plugin
export var base = "_1i-0";
export var updateBanner = "_1i-1";